import React, { Component } from 'react';
import { withRouter }       from 'react-router';
import { connect }          from 'react-redux';
import { Input, Alert }     from 'reactstrap';
import { ClipLoader }       from 'react-spinners';
import { TestConstants }    from '../environment';
import { searchFetchData }  from '../../../../actions/test-maintenance/search';

var apiHost = TestConstants.WebApiHost;

class RetrievePassword extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      search : '',
    };
    
    this.search         = this.search.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }
  
  componentDidMount() {
    this.props.fetchDataSearch(apiHost, null, true);
  }
  
  search() {
    if (this.state.search.length > 1) {
      this.setState({ message: '' }, function() {
        this.props.fetchDataSearch(apiHost, { search: this.state.search });
      });
    }
  }
   
  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.search();
    }
  }
  
  updateSearch(event) {
    this.setState({ search: event.target.value.toLowerCase() });
  }

  render() {
    return (
      <div style={{ marginBottom: '20px' }}>
        { this.props.searchHasErrored ?
          <Alert color='danger' style={{ opacity: 'inherit' }}>
            There was an error finding the requested user
          </Alert>
          :
          <span></span>
        }
        <div>
        <Alert color="warning">
            The password tool has moved!
            <hr />
              You can access the new and improved tool below
        </Alert>

        <a href="https://services.dev.boisestate.edu/password/retrieval">Password Retrieval</a>
        </div>
        <div style={{marginTop: '10px'}}>
          { this.props.searchIsLoading ?
              <ClipLoader
                color={'#072659'} 
                loading={this.props.searchIsLoading} 
              />
              : <span />
          }
        </div>
        { this.props.search && this.props.search.Password ?
          <div style={{marginTop: '10px'}}>
            <p>
              <b>Common Name</b>&nbsp;<span>{this.props.search.UserName}</span>
            </p>
            <p>
              <b>Employee ID</b>&nbsp;<span>{this.props.search.Id}</span>
            </p>
            <p>
              <b>Expiration</b>&nbsp;<span>{this.props.search.Expiration}</span>
            </p>
            <p>
              <b>Password</b>
              <button style={{marginLeft: '5px'}} className='c-btn c-btn--sm' onClick={() => {navigator.clipboard.writeText(this.props.search.Password)}}>
                <span className="c-btn__text">Copy to Clipboard</span>
              </button>
            </p>
          </div>
          :
          <div></div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    search: state.testM.search.search,
    searchHasErrored: state.testM.search.searchHasErrored,
    searchIsLoading: state.testM.search.searchIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataSearch: (host, params, reset) => dispatch(searchFetchData(host, params, reset))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RetrievePassword));
